var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSyria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.12055 0.0107422 3.25587 4.35274 0.995178 10.4456H31.0049C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.011C22.8794 32.011 28.7441 27.669 31.0048 21.5762H0.995178C3.25587 27.669 9.12055 32.011 16 32.011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56057 12.1846L10.4239 14.8416H13.2178L10.9575 16.4839L11.8209 19.1411L9.56057 17.4989L7.30026 19.1411L8.16363 16.4839L5.90332 14.8416H8.69726L9.56057 12.1846Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 12.1846L23.3036 14.8416H26.0976L23.8373 16.4839L24.7006 19.1411L22.4403 17.4989L20.18 19.1411L21.0434 16.4839L18.7831 14.8416H21.577L22.4403 12.1846Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSyria);
export default __webpack_public_path__ + "static/media/flag_syria.ee7fe8820d6df2e16fd2ad5069e3b2b8.svg";
export { ForwardRef as ReactComponent };